<div id="cabecalho" class="container-fluid">
  <fieldset class="panel mb-1">
    <legend>Dados do Atendimento</legend>
    <hr>
    <div class="row">
      <div class="col-md-1">
        <div class="mb-1">
          <label for="nroAtd" class="form-label">Nro. Atd</label>
          <input type="text" class="form-control form-control-sm" id="nroAtd" readonly
                 value="{{ atendimentoAtual?.seq_Agenda ?? '--' }}">
        </div>
      </div>

      <div class="col-md-1">
        <div class="mb-1">
          <label for="data_Agenda" class="form-label">Data</label>
          <input type="text" class="form-control form-control-sm" id="data_Agenda" readonly
                 value="{{ atendimentoAtual?.data_Agenda | date: 'dd/MM/yyyy' }}">
        </div>
      </div>

      <div class="col-md-1">
        <div class="mb-1">
          <label for="seq_Beneficiario" class="form-label">Prontuário</label>
          <input type="text" class="form-control form-control-sm" id="seq_Beneficiario" readonly
                 value="{{ atendimentoAtual?.seq_Beneficiario ?? '--' }}">
        </div>
      </div>

      <div class="col-md-5">
        <div class="mb-1">
          <label for="nomePaciente" class="form-label">Nome do Paciente</label>
          <input type="text" class="form-control form-control-sm" id="nomePaciente" readonly
                 value="{{ atendimentoAtual?.beneficiario?.nome_Beneficiario ?? '--' }}">
        </div>
      </div>

      <div class="col-md-2">
        <div class="mb-1">
          <label for="data_Nascimento" class="form-label">Dt. Nascimento</label>
          <input type="text" class="form-control form-control-sm" id="data_Nascimento" readonly
                 value="{{ atendimentoAtual?.beneficiario?.data_Nascimento | date: 'dd/MM/yyyy' }}">
        </div>
      </div>

      <div class="col-md-2">
        <div class="mb-1">
          <label for="birthdate" class="form-label">Idade</label>
          <input type="text" class="form-control form-control-sm" id="birthdate" readonly value="{{ atendimentoAtual?.beneficiario?.data_Nascimento | idade }}">
        </div>
      </div>
    </div>
    <div class="row">

      <div class="col-md-2">
        <div class="mb-1">
          <label for="estado_Civil" class="form-label">Estado Civil</label>
          <input type="text" class="form-control form-control-sm" id="estado_Civil" readonly
                 value="{{ atendimentoAtual?.beneficiario?.estado_Civil ?? '--' }}">
        </div>
      </div>

      <div class="col-md-2">
        <div class="mb-1">
          <label for="profissao" class="form-label">Profissão</label>
          <input type="text" class="form-control form-control-sm" id="profissao" readonly
                 value="{{ atendimentoAtual?.beneficiario?.profissao?.descricao_Profissao ?? '--' }}">
        </div>
      </div>

      <div class="col-md-4">
        <div class="mb-1">
          <label for="nome_Mae" class="form-label">Nome da Mãe</label>
          <input type="text" class="form-control form-control-sm" id="nome_Mae" readonly
                 value="{{ atendimentoAtual?.beneficiario?.nome_Mae }}">
        </div>
      </div>

      <div class="col-md-4">
        <div class="mb-1">
          <label for="nome_Pai" class="form-label">Nome do Pai</label>
          <input type="text" class="form-control form-control-sm" id="nome_Pai" readonly
                 value="{{ atendimentoAtual?.beneficiario?.nome_Pai }}">
        </div>
      </div>

    </div>

    <div class="row">

      <div class="col-md-2">
        <div class="mb-1">
          <label for="atendimentoAtual_cid_10" class="form-label">CID-10</label>
          <input type="text" class="form-control form-control-sm" id="atendimentoAtual_cid_10" readonly
                 value="{{ atendimentoAtual?.cid10?.cid_10 ?? '--' }}">
        </div>
      </div>

      <div class="col-md-4">
        <div class="mb-1">
          <label for="atendimentoAtual_descricao_Cid" class="form-label">Descrição do CID-10</label>
          <input type="text" class="form-control form-control-sm" id="atendimentoAtual_descricao_Cid" readonly
                 value="{{ atendimentoAtual?.cid10?.descricao_Cid ?? '--' }}">
        </div>
      </div>

      <div class="col-md-4">
        <div class="mb-1">
          <label for="descricao_Plano_Operadora" class="form-label">Operadora</label>
          <input type="text" class="form-control form-control-sm" id="descricao_Plano_Operadora" readonly
                 value="{{ atendimentoAtual?.plano?.descricao_Plano_Operadora ?? 'PARTICULAR' }} / {{ atendimentoAtual?.plano?.operadora?.nome_Operadora ?? 'PARTICULAR' }}">
        </div>
      </div>

    </div>
  </fieldset>

  <div class="row">
    <div class="col-md-10">
      <div class="panel">
        <legend>Profissional Executante</legend>
        <div class="row">

          <div class="col-md-1">
            <div class="mb-1">
              <label for="descricao_Conselho" class="form-label">Conselho</label>
              <input type="text" class="form-control form-control-sm" id="descricao_Conselho" readonly
                     value="{{ atendimentoAtual?.corpoClinico?.profissional?.descricao_Conselho ?? '--' }}">
            </div>
          </div>

          <div class="col-md-2">
            <div class="mb-1">
              <label for="num_Conselho" class="form-label">Número</label>
              <input type="text" class="form-control form-control-sm" id="num_Conselho" readonly
                     value="{{ atendimentoAtual?.corpoClinico?.profissional?.num_Conselho ?? '--' }}">
            </div>
          </div>

          <div class="col-md-1">
            <div class="mb-1">
              <label for="sigla_UF" class="form-label">UF</label>
              <input type="text" class="form-control form-control-sm" id="sigla_UF" readonly
                     value="{{ atendimentoAtual?.corpoClinico?.profissional?.sigla_UF ?? '--' }}">
            </div>
          </div>

          <div class="col-md-5">
            <div class="mb-1">
              <label for="nomeProfissional" class="form-label">Nome do Profissional</label>
              <input type="text" class="form-control form-control-sm" id="nomeProfissional" readonly
                     value="{{ atendimentoAtual?.corpoClinico?.profissional?.nome ?? '--' }}">
            </div>
          </div>

          <div class="col-md-3">
            <div class="mb-1">
              <label for="descricao_Clinica" class="form-label">Clínica</label>
              <input type="text" class="form-control form-control-sm" id="descricao_Clinica" readonly
                     value="{{ atendimentoAtual?.corpoClinico?.setoresClinica?.descricao_Clinica ?? '--' }}">
            </div>
          </div>

        </div>
      </div>
    </div>
    <div id="cid10" class="col">
      <div class="panel">
        <legend>CID-10</legend>
        <label for="codigoCid" class="form-label">CID</label>
        <div class="input-group mb-1">
          <input type="text" class="form-control form-control-sm" id="codigoCid" [(ngModel)]="codigoCid" [disabled]="atendimentoAtual?.isTravada ?? true">
          <button type="button" class="btn btn-sm btn-primary" (click)="abrirModal(myModal)" [disabled]="(atendimentoAtual?.isTravada ?? true) || !codigoCid">Confirmar</button>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #myModal let-modal>
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title">Buscar CID-10</h4>
      <button type="button" class="close" (click)="modal.dismiss('Cross click')">
        <span>&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="table-responsive">
        <table class="table table-sm table-striped table-hover">
          <thead>
          <tr>
            <th scope="col">Código</th>
            <th scope="col">Descricao</th>
            <th scope="col">Ação</th>
          </tr>
          </thead>
          <tbody>
            <tr *ngFor="let cid of codigosCid">
              <td>{{ cid.cid_10 }}</td>
              <td>{{ cid.descricao_Cid }}</td>
              <td><button type="button" class="btn btn-sm btn-primary" (click)="selecionarCid(cid); modal.dismiss('Cross click')" [disabled]="atendimentoAtual?.isTravada ?? true">Selecionar</button></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="modal.close('Fechar')">Fechar</button>
    </div>
  </div>
</ng-template>



